import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { IImageList } from '@web-nx-ng-tsc/web-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
import { RouterLink } from '@angular/router';
import { ROUTER_TOKENS } from '../../../../../../../apps/promo-web/web-toyo/src/app/app.routes';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-promotion-card',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './lib-promotion-card.component.html',
  styleUrl: './lib-promotion-card.component.scss',
})
export class LibPromotionCardComponent {
  @Input() set data(value: IImageList) {
    this.dataSignal.set(value);
    this.loggingService.log('dataSignal', value);
  }
  @Input() headingLevel: 'h2' | 'h3' = 'h2';

  private readonly loggingService = inject(LoggingService);
  protected readonly ROUTER_TOKENS = ROUTER_TOKENS;
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<IImageList>({
    img: '',
    title: '',
    excerpt: '',
    id: 0,
  });
}
